<div class="appModalContent__container">
  <ng-content></ng-content>
</div>
